import { render, staticRenderFns } from "./FilterProcess.vue?vue&type=template&id=2b407570"
import script from "./FilterProcess.vue?vue&type=script&lang=js"
export * from "./FilterProcess.vue?vue&type=script&lang=js"
import style0 from "./FilterProcess.vue?vue&type=style&index=0&id=2b407570&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports